<template>
    <div>
        <div class="container">
            <e-search
                    :data="filterInfo.data"
                    :field-list="filterInfo.fieldList"
                    :list-type-info="listTypeInfo"
                    @handleFilter="handleFilter"
                    @handleReset="handleReset"
            ></e-search>
        </div>
        <div class="content-wrapper container">
            <div class="flex">
                <div v-if="showBatchBtn" class="flex margin-r20">
                    <eui-btn type="primary" class="margin-b20 margin-t10" @click="handleAllCheck"
                             v-if="this.selectData.length === 0">全选
                    </eui-btn>
                    <eui-btn type="primary" class="margin-b20 margin-t10" @click="handleCancleCheck" v-else>取消全选
                    </eui-btn>
                </div>
                <eui-btn type="primary" v-if="showBatchBtn" class="margin-b20 margin-t10" @click="handleBatchAdd">批量设置
                </eui-btn>
            </div>

            <div class="content-flex">
                <div class="content-left margin-r10">
                    <el-tree :data="data"
                             node-key="id"
                             ref="tree"
                             :check-strictly="true"
                             :props="defaultProps"
                             @node-click="handleNodeClick"
                             @check-change="handleCheckChange"
                             show-checkbox
                             :default-checked-keys="checkedKeys"
                             :expand-on-click-node="false">
                        <div slot-scope="{ node, data }" class="tree-box name-box">
                            {{node.label}}
                            <eui-btn v-if="showAllBtn" type="text" @click="createShareData(data)">创建份额控制</eui-btn>
                        </div>
                    </el-tree>
                </div>
                <div class="content-right">
                    <tableList
                            class="margin-b20"
                            rowKey="id"
                            :indexShow="true"
                            :loading="false"
                            maxHeight="500"
                            :table-data="tableData"
                            :table-label="tableLabel"
                    >
                        <template #operate="slot">
                            <div v-if="showAllBtn">
                                <eui-btn type="text" @click="handleEdit(slot.scope.row)">修改</eui-btn>
                                <!--                                &lt;!&ndash;状态（1：启用；2：停用；）&ndash;&gt;-->
                                <!--                                <eui-btn type="text" v-if="slot.scope.row.status === 1"-->
                                <!--                                         @click="handleShareDisabled(slot.scope.row.id)">停用-->
                                <!--                                </eui-btn>-->
                                <!--                                <eui-btn type="text" v-if="slot.scope.row.status === 2"-->
                                <!--                                         @click="handleShareEnabled(slot.scope.row.id)">启用-->
                                <!--                                </eui-btn>-->
                                <eui-btn type="text" @click="handleDel(slot.scope.row)">删除</eui-btn>
                                <eui-btn type="text" @click="viewShareChange(slot.scope.row)">份额变动记录</eui-btn>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </tableList>
                    <div class="flex-r">
                        <el-pagination
                                background
                                :page-sizes="[10, 20,50,100,200]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :current-page="queryData.pageNum"
                                :page-size="queryData.pageSize"
                                :total="queryData.pageTotal"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"/>
                    </div>
                </div>
            </div>
        </div>
        <!--新增-->
        <share-setting-dialog
                v-if="shareSetVisible"
                :shareSetVisible.sync="shareSetVisible"
                :shareData="shareData"
        />
        <!--份额变动记录-->
        <share-change-dialog
                v-if="shareChangeVisible"
                :shareChangeVisible.sync="shareChangeVisible"
                :changeId="changeId"
        />
    </div>
</template>

<script>
import eSearch from '../../components/common/e-search';
import tableList from '../../components/common/e-table-list';
import shareSettingDialog from './components/shareSettingDialog';
import shareChangeDialog from './components/shareChangeDialog';
import api from '@/modules/projectA/api/purchase';

export default {
  components: {
    eSearch,
    tableList,
    shareSettingDialog,
    shareChangeDialog,
  },
  data() {
    return {
      isRoot: false,
      isInGroupFlag: false,//是否在集团中
      isAdminFlag: false,//是否是 采购商管理员、供应商管理员 ，任一返回true
      showAllBtn: false,
      showBatchBtn: false,//是否展示批量设置
      companyId: '',
      selectData: [],
      data: [],
      allNodeIds: [],
      checkedKeys: [],
      nodeArr: [],
      defaultProps: {
        label: 'companyName',
        children: 'children',
      },
      shareData: {
        handleType: '',//one、more
        showName: ''
      },
      isEdit: false,
      shareSetVisible: false,
      shareChangeVisible: false,
      changeId: "",
      filterInfo: {
        data: {
          timeType: null,
          status: null,
          purchaseCompanyName: null,
        },
        fieldList: [],
      },
      fieldList: [
        {
          label: '生成方式',
          type: 'select',
          value: 'timeType',
          list: 'effectMethodList',
        },
        // {label: '方案状态', type: 'select', value: 'status', list: 'statusList'},
      ],
      listTypeInfo: {
        statusList: [
          {id: null, name: '全部'},
          {id: 1, name: '启用'},
          {id: 2, name: '停用'},
        ],
        effectMethodList: [
          {id: null, name: '全部'},
          {id: 2, name: '长期生效'},
          {id: 1, name: '指定周期'},
        ],
        companyList: [],
      },
      queryData: {
        timeType: null,
        status: null,
        purchaseCompanyName: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      tableData: [],
      tableLabel: [
        {
          label: '方案生效方式',
          param: 'timeType',
          align: 'center',
          width: '100px',
          render: (row) => {
            let obj = {
              1: '指定周期',
              2: '长期有效',
            };
            return obj[row.timeType];
          },
        },
        {label: '组织结构名称', param: 'purchaseCompanyName', align: 'center', tooltip: true, width: '100px',},
        {label: '创建时间', param: 'createTime', align: 'center', tooltip: true, width: '100px',},
        {label: '生效时间', param: 'specifyTimeStart', align: 'center', tooltip: true, width: '100px',},
        {label: '失效时间', param: 'specifyTimeEnd', align: 'center', tooltip: true, width: '100px',},
        // {
        //   label: '状态', param: '', align: 'center', render: (row) => {
        //     let obj = {
        //       1: '启用',
        //       2: '停用',
        //     };
        //     return obj[row.status];
        //   },
        // },
        {label: '控制金额', param: 'totalAmount', align: 'center', width: '100px',},
        {label: '单笔限额', param: 'singleOrderAmount', align: 'center', width: '100px',},
        {label: '操作', param: '', align: 'center', slot: 'operate', fixed: 'right', width: '200px'},
      ],
    };
  },
  methods: {
    //取消全选
    handleCancleCheck() {
      this.checkedKeys = [];
      this.selectData = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    //全选
    handleAllCheck() {
      this.checkedKeys = this.allNodeIds;
    },
    // 辅助方法：递归收集所有节点的ID
    collectAllNodeIds(nodes) {
      let ids = [];
      nodes.forEach(node => {
        ids.push(node.id);
        this.nodeArr.push(node);
        if (node.children && node.children.length > 0) {
          ids = ids.concat(this.collectAllNodeIds(node.children));
        }
      });
      return ids;
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.purchaseShareQueryPage();
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.purchaseShareQueryPage();
    },
    //右侧列表
    async purchaseShareQueryPage() {
      const res = await api.purchaseShareQueryPage(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total;
        if (this.isEdit) {
          this.shareSetVisible = true;
          this.isEdit = false;
        }
      }
    },
    //创建份额控制
    createShareData(data) {
      this.shareData = {
        handleType: 'leftAdd',
        showName: data.companyName,
        purchaseCompanyId: data.companyId,
        purchaseCompanyName: data.companyName,
        id: data.id,
      };
      this.shareSetVisible = true;
    },
    //启用
    async handleShareEnabled(id) {
      const res = await api.purchaseShareEnabled({id: id});
      if (res.code === '200') {
        this.$message.success('启用成功。')
        this.purchaseShareQueryPage();
      }
    },
    //停用
    async handleShareDisabled(id) {
      const res = await api.purchaseShareDisabled({id: id});
      if (res.code === '200') {
        this.$message.success('停用成功。')
        this.purchaseShareQueryPage();
      }
    },

    //删除
    async handleDel(row) {
      this.$confirm(`您正在删除一个份额控制方案，此操作无法恢复，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(async () => {
        this.purchaseShareDel(row);
      });
    },
    async purchaseShareDel(row) {
      const res = await api.purchaseShareDel({id: row.id});
      if (res.code === '200') {
        this.$message.success('删除成功。')
        this.purchaseShareQueryPage();
      }
    },
    handleEdit(row, leftAdd) {
      this.shareData = {
        handleType: 'edit',
        showName: row.purchaseCompanyName,
        purchaseCompanyId: row.companyId,
        purchaseCompanyName: row.companyName,
        id: row.id,
        leftAdd
      };
      this.shareSetVisible = true;
    },
    viewShareChange(row) {
      this.changeId = row.id;
      this.shareChangeVisible = true;
    },
    handleNodeClick(data) {
      // this.queryData.purchaseCompanyName = data.companyName;
      this.queryData.purchaseCompanyId = data.companyId;
      this.purchaseShareQueryPage();
    },
    handleCheckChange(data, checked) {
      if (checked) {
        this.selectData.push(data);
      } else {
        const indexNum = this.selectData.findIndex(item => item.companyId === data.companyId);
        this.selectData.splice(indexNum, 1);
      }

      this.selectData = [...new Set(this.selectData)]

      if (this.selectData.length == 0) {
        this.checkedKeys = [];
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    //单个设置份额  如果有值当作修改处理
    handleAdd(data) {
      //单个增加得值
      this.shareData = {
        handleType: 'one',
        showName: data.companyName,
        purchaseCompanyId: data.companyId,
        purchaseCompanyName: data.companyName,
      };
      this.shareSetVisible = true;
    },
    //批量设置份额
    handleBatchAdd() {
      if (this.selectData.length == 0) {
        this.$message.warning('请勾选。')
        return false;
      }
      const companyList = this.selectData.map(({companyId, companyName}) => ({
        purchaseCompanyId: companyId,
        purchaseCompanyName: companyName
      }));
      this.shareData = {
        handleType: 'more',
        showName: `已勾选${this.selectData.length}家公司`,
        companyList: companyList,
      };
      this.shareSetVisible = true;
    },
    handleFilter(val) {
      this.queryData = val;
      this.queryData.pageNum = 1;
      this.purchaseShareQueryPage();
    },
    handleReset() {
      this.queryData = {
        timeType: null,
        status: null,
        purchaseCompanyName: null,
      }
      this.purchaseShareQueryPage();
    },
    //获取左侧树
    async queryCurrentGroup() {
      const res = await api.queryCurrentGroup();
      if (res.code === '200') {

        if (res.data) {
          this.data = [res.data] || [];
          // 遍历树结构，收集所有节点的ID
          this.allNodeIds = this.collectAllNodeIds(this.data);
        }

        this.groupJudge();
      }
    },
    //当前公司是否在集团中，是否是根节点，是否是根节点管理员，是否是管理员
    async groupJudge() {
      const res = await api.groupJudge();
      if (res.code === '200') {
        const {group, root, rootAdmin, admin,} = res.data;

        //展示集团树 根节点公司
        if (group && root) {
          if (rootAdmin) {//可以设置份额
            this.showAllBtn = true;
            this.showBatchBtn = true;
            this.filterInfo.fieldList.unshift({label: '公司全称', type: 'input', value: 'purchaseCompanyName'})
          }

        } else if (group && !root) {//非集团架构公司 只展示当前公司名称 没有按钮 不可以设置份额
          this.dealCurrentCompany();
        } else if (!group) {//展示当前公司名称
          this.dealCurrentCompany();
          if (admin) {//可以  创建份额控制
            this.showAllBtn = true;
          }
        }
      }
    },
    //只展示当前公司
    dealCurrentCompany() {
      const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
      let params = [{
        id: '',
        companyId: userInfo.companyId,
        companyName: userInfo.companyName,
        parentId: 0
      }]
      this.data = params;
    },
    //1.是否是根节点公司  2.供应商管理员、采购商管理员 都满足才展示
    isRootAdmin() {
      if (this.isInGroupFlag) {//是集团架构
        if (this.isRoot && this.isAdminFlag) {
          this.showAllBtn = true;
          this.showBatchBtn = true;
          this.filterInfo.fieldList.unshift({label: '公司全称', type: 'input', value: 'purchaseCompanyName'})
        }
      } else {//非集团架构
        this.showBatchBtn = false;
        if (this.isAdminFlag) {
          this.showAllBtn = true;
        }
      }
    },
  },
  mounted() {
    this.filterInfo.fieldList = this.fieldList;
    this.queryCurrentGroup();
  },
  watch: {
    checkedKeys(newV) {
      if (newV.length > 0) {
        this.selectData = this.nodeArr;
      } else {
        this.selectData = [];
      }
    }
  },
};
</script>

<style scoped lang="scss">
.content-wrapper {
    height: 600px;
    overflow-y: auto;
    width: 100%;

    .content-flex {
        display: flex;

        .content-left {
            padding: 10px;
            height: 500px;
            border: 1px solid #d9d9d9;
            flex: 1;

            .name-box {
                font-size: 14px;
                color: #333;
            }
        }

        .content-right {
            flex: 2;
            min-width: 0;
        }
    }
}
</style>
